import storage from '../../../storage';
import logger from "../../../logger.js";
import ExceptionWrongPassword from "@/exceptions/ExceptionWrongPassword.js";
import ExceptionBadResponse from "@/exceptions/ExceptionBadResponse.js";
// import Axios
import Axios from 'axios';
// instantiate axios
const axios = Axios.create();
// setup query endpoint
const secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
const endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY;

function createSession(user) {
    
    return axios.post(endpoint + "/api/session-new/create", user) // eslint-disable-next-line
        .then(response => {
            if(response.status === 200 && response.data.status === 'success') { //todo maybe check response.data.token and .roles directly
                storage.onConnect()
                    .then(() => {
                        return storage.set('token', response.data.token)
                    })
                    .then(() => {
                        if(JSON.stringify(response.data.roles).length > 2){
                            return storage.set('roles', JSON.stringify(response.data.roles))
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        })
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`component: RegisterHotel, url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            if (error.response.status == 401 && error.response.data.message == "Invalid credentials!") throw new ExceptionWrongPassword();
            throw new ExceptionBadResponse();
        });
}

function destroySession(user) {
    
    return axios.post(endpoint + "/api/session-new/destroy", user) // eslint-disable-next-line
        .then(response => {
            if(response.status === 200 && response.data.status === 'success') { //todo maybe check response.data.token and .roles directly
                storage.onConnect()
                    .then(() => {
                        return storage.del('token')
                    })
                    .then(() => {
                        return storage.del('roles')
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        })
        .catch(error => {
            if(error.response) {
                    let url = error.response.config.url?error.response.config.url:'';
                    let status = error.response.status;
                    let message = error.response.data.message ? error.response.data.message : error.response.data.error.message;
                    logger.error(`component: RegisterHotel, url: ${url}, status: ${status}, message: ${message}`, error.stack)
                        .then(() => null)
                } else {
                    logger.error(error.message, error.stack)
                        .then(() => null);
                }
            throw new ExceptionBadResponse();
        });
}

export default {
  createSession,
  destroySession,
};
